enum NumberFormats {
  Currency = 'currency',
  Decimal = 'decimal',
  Percentage = 'percent',
}

export default NumberFormats;
